import { PlusIcon, QuestionIcon } from '@phosphor-icons/react'
import { DefaultButton } from '../../../components/buttons/default-button.tsx'
import { TooltipWithHover } from '../../../components/tooltip.tsx'
import { CatalogBrandIcon } from './integration-icon.tsx'
import type { CatalogEntry } from './integration-instance-utils.ts'
import * as styles from './integrations-tab.css.ts'

type ToolCatalogCardProps = {
  entry: CatalogEntry
  onAdd: (opener: HTMLElement) => unknown
  onViewDocs: (opener: HTMLElement) => unknown
}

export const ToolCatalogCard: React.FC<ToolCatalogCardProps> = ({ entry, onAdd, onViewDocs }) => {
  return (
    <div className={styles.catalogCard}>
      <div className={styles.catalogCardBranding}>
        <CatalogBrandIcon icon={entry.icon} />
        <p className={styles.catalogCardName}>{entry.label}</p>
      </div>

      <div className={styles.catalogCardActions}>
        {entry.isAddable && (
          <TooltipWithHover
            trigger={
              <DefaultButton
                buttonType="secondary"
                size="small"
                className={styles.addButton}
                onClick={event => onAdd(event.currentTarget)}
                state="default"
                ariaLabel={`Add ${entry.label}`}
              >
                <PlusIcon size={16} />
              </DefaultButton>
            }
          >
            {`Add ${entry.label}`}
          </TooltipWithHover>
        )}

        <TooltipWithHover
          trigger={
            <button
              type="button"
              className={styles.docsButton}
              onClick={event => onViewDocs(event.currentTarget)}
              aria-label={`View ${entry.label} documentation`}
            >
              <QuestionIcon size={20} weight="regular" />
            </button>
          }
        >
          View documentation
        </TooltipWithHover>
      </div>
    </div>
  )
}
